export default {
    loading: false,
    error: false,
    items: [],
    project: [],
    bot: [],
    advanced: {},
    playbooks: [],
    playbooksEdits:{
      result: {}
    },
    idToEdit: 0,
    pagination: {
      limit: 10,
      page: 0,
      total: 0
    }
  }
  